import React, { ComponentType, KeyboardEvent, memo, ReactNode } from 'react'

import { InputMemo } from './Input'

import s from './InputWithIcon.module.less'

export interface IInputWithIconProps {
  onChange: (value: string) => void
  placeholder: string
  value: string
  Icon?: ComponentType<ISvgIconProps>
  autoFocus?: boolean
  className?: string
  desktopParentElement?: ReactNode
  isDisabled?: boolean
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
  testId?: string
}

export const InputWithIcon = memo(function InputWithIcon({
  className,
  value,
  placeholder,
  autoFocus = false,
  isDisabled,
  onChange,
  onKeyDown,
  desktopParentElement,
  testId
}: IInputWithIconProps) {
  return (
    <div className={s.inputWrapper}>
      <InputMemo
        autoFocus={autoFocus}
        className={className}
        desktopParentElement={desktopParentElement}
        disabled={isDisabled}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        testId={testId}
        value={value}
      />
    </div>
  )
})
